module.exports = "https://99designs-start-assets.imgix.net/js/b544f21b4cedd4d222492a7a019f2ee9.jpg";